// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Pledge } from './pledge';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PledgeLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get sortValue() {
        return this.expectedDate || new Date(2999, 1, 1); //  moment('1/1/2999').toDate()
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  amount!: number;
  deleted?: Date;
  deletedBy?: string;
  expectedDate?: Date;
  note?: string;
  pledgeId!: string;
  pledge!: Pledge;
}

